import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const TipoCuentaService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Cuenta_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_tipo_cuenta: null,
			clave: form.clave,
			tipo_cuenta: form.tipo_cuenta,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Cuenta_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_tipo_cuenta: form.id_cat_tipo_cuenta,
			clave: form.clave,
			tipo_cuenta: form.tipo_cuenta,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Cuenta_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_tipo_cuenta) => {
		let params = {
			id_cat_tipo_cuenta: id_cat_tipo_cuenta
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Cuenta_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
